import React from "react"
import { Form, useNavigate } from "react-router-dom"
import { Api } from "../lib/api"
import { unrollError, createStripeCustomer } from "../lib/util"

import {
  Alert,
  Button,
  FormControl,
  Heading,
  Input,
  Text,
  VStack,
} from "@chakra-ui/react"

import { CurrentOrgId } from "../lib/store"
import GradientBox from "./GradientBox"

// This is the URL to redirect to after the organization is created.
// Previously this redirected to the Intercom tour but now we're just going to
// redirect to the choose plan page, the pricing table will redirect to the Intercom tour.
// const POST_ACTIVATION_REDIRECT_URL = -1
const POST_ACTIVATION_REDIRECT_URL = "/datasets?product_tour_id=528227"

export default function OrganizationCreate() {
  const [error, setError] = React.useState(null)
  const navigate = useNavigate()
  const api = new Api()
  const currentOrgId = CurrentOrgId.getValue()

  React.useEffect(() => {
    // If the user already has an organization, redirect them to the main application
    // This prevents users from creating multiple organizations and handles direct
    // navigation to this page when an organization already exists
    if (currentOrgId) {
      console.log(
        "User already has an organization, redirecting to",
        POST_ACTIVATION_REDIRECT_URL,
      )
      navigate(POST_ACTIVATION_REDIRECT_URL)
    }
  }, [currentOrgId])

  async function handleSubmit(e) {
    e.preventDefault()
    try {
      // Create the organization; get the response
      const org = await api.organizationsCreate(e.target.name.value)
      const orgs = [org]
      api.setOrFindOrganization(orgs)
      // Create a Stripe customer for the user without waiting for the response.
      createStripeCustomer()
      // navigate("/choose-plan")
      navigate(POST_ACTIVATION_REDIRECT_URL)
    } catch (e) {
      console.log("Error creating organization", e)
      setError(await unrollError(e))
    }
  }

  return (
    <GradientBox>
      <VStack minWidth="100%" justifyContent="space-between" alignItems="left">
        <Form onSubmit={handleSubmit}>
          <Heading variant="standard">Create an Organization</Heading>
          {error && <Alert status="error">{error}</Alert>}
          <FormControl mt="3em" display="flex" flexDirection="column">
            <Input
              variant="account"
              name="name"
              placeholder="Name"
              isRequired
            />
            <Text variant="subtext">
              A human-readable name for your organization.
            </Text>
            <VStack spacing="1.5vh" mt="3vh">
              <Button
                variant="primary"
                type="submit"
                title="Create Organization"
              >
                Create
              </Button>
            </VStack>
          </FormControl>
        </Form>
      </VStack>
      <span />
    </GradientBox>
  )
}
